import { useTranslation } from 'react-i18next';

export const useTranslationSetup = () => {
  const { t } = useTranslation();
  return { t };
};
